
import { Clock } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { CurrentOrderView } from "@/components/menu/public/CurrentOrderView";
import { Order } from "@/types/orders";
import { useTranslation } from "react-i18next";

interface OrderContentTabProps {
  pendingOrders: Order[];
  hasActiveOrders: boolean;
  activeOrders: Order[];
  storeId: string;
  tableId: string;
  storeName?: string;
  setActiveTab: (tab: string) => void;
}

export function OrderContentTab({
  pendingOrders,
  hasActiveOrders,
  activeOrders,
  storeId,
  tableId,
  storeName,
  setActiveTab
}: OrderContentTabProps) {
  const { t } = useTranslation();

  return (
    <TabsContent value="order" className="space-y-4">
      {hasActiveOrders ? (
        <div className="space-y-6">
          {/* Display only pending, preparing, ready orders, not delivered or completed */}
          {pendingOrders
            .filter(order => order.status !== "cancelled")
            .map((order) => (
              <CurrentOrderView
                key={order.id}
                order={order}
                storeId={storeId}
                tableId={tableId}
                storeName={storeName}
              />
            ))}

          {pendingOrders.length === 0 && activeOrders.length > 0 && (
            <div className="text-center p-8 bg-white rounded-lg border shadow-sm">
              <Clock className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
              <h3 className="text-lg font-medium">{t("allOrdersReady")}</h3>
              <p className="text-muted-foreground mt-2 mb-4">
                {t("allYourOrdersAreReadyForPickup")}
              </p>
              <Button onClick={() => setActiveTab("menu")}>
                {t("orderMore")}
              </Button>
            </div>
          )}
        </div>
      ) : (
        <div className="text-center p-8 bg-white rounded-lg border shadow-sm">
          <Clock className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
          <h3 className="text-lg font-medium">{t("noActiveOrders")}</h3>
          <p className="text-muted-foreground mt-2 mb-4">
            {t("browseMenuAndPlaceOrder")}
          </p>
          <Button onClick={() => setActiveTab("menu")}>
            {t("viewMenu")}
          </Button>
        </div>
      )}
    </TabsContent>
  );
}
